module.exports = __webpack_public_path__ + "img/942.630a9b79.png";